import { render, staticRenderFns } from "./deleteAddress.vue?vue&type=template&id=f1c848fc&scoped=true&"
import script from "./deleteAddress.vue?vue&type=script&lang=js&"
export * from "./deleteAddress.vue?vue&type=script&lang=js&"
import style0 from "./deleteAddress.vue?vue&type=style&index=0&id=f1c848fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c848fc",
  null
  
)

export default component.exports